import { ToggleSwitch as FlowbiteToggleSwitch } from "flowbite-react";
export { FlowbiteToggleSwitch as ToggleSwitch };
